$(document).ready(function() {	
  var modal = document.getElementById("gradeModal");

  var modal1 = document.getElementById("productModal");
  var modalCosmeticGrading = document.getElementById("cosmeticgradingModal");

  $('.tooltip').click(function(event){
    var modalID = event.target.id;	

    if(modalID == 'product-tooltip'){
      modal1.style.display = "block";
    }
    else if (modalID == 'grade-tooltip'){
      modal.style.display = "block";
    } else if (modalID == 'cosmetic-grading-tooltip') {
      modalCosmeticGrading.style.display = "block";
      let buttonSelectedValue = document.querySelector('.pa_cosmetic-grading input:checked').getAttribute('value');
      let modalTriggerTab = document.querySelector('.pa_tablinks[value="' + buttonSelectedValue + '"]:not(.active)');
      if (modalTriggerTab) {
        modalTriggerTab.click();
      }
      // document.querySelector('.pa_tablinks').click();
    }
    else{
      return false;
    }
  });

  $('.close').click(function(event){
    modal.style.display = "none";
  });

  $('.close2').click(function(event){
    modal1.style.display = "none";
    modalCosmeticGrading.style.display = "none";
  });
});